// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

export function tiposChavePixRequest(): ReducerAction {
	return {
		type: Types.TIPOS_CHAVE_PIX_REQUEST,
		payload: null,
	};
}
export function tiposChavePixSuccess(payload: object): ReducerAction {
	return {
		type: Types.TIPOS_CHAVE_PIX_SUCCESS,
		payload,
	};
}
export function tiposChavePixFailure(payload: object): ReducerAction {
	return {
		type: Types.TIPOS_CHAVE_PIX_FAILURE,
		payload,
	};
}
export function tiposChavePixClear(): ReducerAction {
	return {
		type: Types.TIPOS_CHAVE_PIX_CLEAR,
		payload: null,
	};
}
